// extracted by mini-css-extract-plugin
export var container = "_8g-0";
export var error = "_8g-9";
export var label = "_8g-5";
export var light = "_8g-6";
export var md = "_8g-3";
export var sm = "_8g-2";
export var thin = "_8g-8";
export var thinBold = "_8g-7";
export var vertical = "_8g-4";
export var xs = "_8g-1";